/**
 * One value per stage with a fallback, as in `{ default: false, production: true }`.
 * Env config keys (`withModeDefault`) and feature flags both declare their
 * stage defaults in this shape.
 */
export type StageDefaults<S extends string, A> = {
  readonly default: A;
} & Partial<Readonly<Record<S, A>>>;

export const defaultForStage = <S extends string, A>(
  defaults: StageDefaults<S, A>,
  stage: S,
) => defaults[stage] ?? defaults.default;
